import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const ReprintCidSearchPersonCrubs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca persona',
    path: '/sportello/ristampa-carta/ricerca-persona',
  },
];

export const ReprintCidCrubs = [
  ...ReprintCidSearchPersonCrubs,
  {
    name: 'Stampa busta CIE',
    path: '/sportello/ristampa-carta/ricerca-persona/ristampa',
  },
];
